function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 10.45,
  cy: 10.45,
  r: 10
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M362.84,296.7H373.5a5.56,5.56,0,0,1-10.66,0Z",
  transform: "translate(-357.55 -284.55)"
});
var _ref4 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "12 8.3 13.45 6.67 14.94 8.16"
});
var _ref5 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "6.31 8.3 7.76 6.67 9.24 8.16"
});
function SvgSmilyDeselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.9 20.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Smily-deselected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilyDeselected);
export default __webpack_public_path__ + "static/media/SmilyDeselected.638a144d.svg";
export { ForwardRef as ReactComponent };